<template>
  <div>
    <header id="masthead" class="registration deleteAccount">
      <div class="wp800">
        <router-link :to="{ name: 'home' }">
          <a class="logo"></a>
        </router-link>
      </div>
    </header>
    <section>
      <!-- delete account step 2 -->
      <div class=" changePassword popUp wp800 contentWithFlex">
        <div class="flex">
          <img src="@/assets/images/confirm.svg" class="mainImageWindow"/>
          <div class="rightText">
            <h3>{{ $t("profile.change_password_success") }}</h3>
            <p>{{ $t("profile.change_password_text") }}</p>

            <a class="join hoverEffect" v-on:click="sendToLogin"><label>{{ $t("profile.change_password_button") }}</label><span class="effect"></span><img src="@/assets/images/nextArrowAnimation.svg"></a>
          </div>
        </div>
      </div>
    </section>
  </div>

</template>
<script>
export default {
  name: "ChangePasswordSuccess",
  data() {
    return{

    }
  },
  methods:{
    sendToLogin(){
      this.$store.dispatch("user/logout");
      this.$router.replace({ name: "login" });
    }
  }
};
</script>
<style scoped>
  a{
    cursor: pointer;
  }
</style>